export default __webpack_public_path__ + "static/media/Individual_Attention.c25602ea.png";